import request from '@/utils/requestold'


/**
 * 首页数据展示
 * $data 参数传递 
 * 【必填 competition_id】
 */
export function selectPathData(data) {
	return request({
		url: '/api/contest/show_index',
		method: 'post',
		data
	})
}

/**
 * 比赛提交
 * @param {*} data 
 * 【必填 competition_id student_id】
 */
export function competitionPost(data){
	return request({
		url: '/api/contest/competition_submit',
		method: 'post',
		data
	})
}

/**
 * 打开比赛的单个活动（试卷）入口页entrance
 * @param {*} data 
 * 【必填 competition_id paper_id uid】
 */
export function userOpenTestData(data){
    return request({
		url: '/api/contest/show_entrance',
		method: 'post',
		data
	})
}

/**
 * 试卷预览
 * @param {*} data 
 * 【必填 paper_id】
 */
export function paperPreviewData(data){
	return request({
		url: '/api/contest/paper_preview',
		method: 'post',
		data
	})
}

/**
 * 考生开始答题
 * @param {*} data
 * 【必填 competition_id paper_id student_id】 
 */
export function userOpenTestAnswerData(data){
	return request({
		url: '/api/contest/answer_topic',
		method: 'post',
		data
	})
}

/**
 * 单题提交
 * @param {*} data 
 * 【必填 competition_id paper_id studeng_id title_type title_id】
 */
export function userSubmitTopicData(data){
	return request({
		url: '/api/contest/submit_topic',
		method: 'post',
		data
	})
}

/**
 * 考生交卷
 * @param {*} data 
 * 【必填 competition_id paper_id student_id】 
 */
export function userSubmitPaperData(data){
	return request({
		url: '/api/contest/submit_paper',
		method: 'post',
		data
	})
}

/**
 * 查看成绩
 * @param {*} data 
 * 【必填 competition_id paper_id student_id】
 */
export function checkPaperResultData(data){
	return request({
		url: '/api/contest/check_result',
		method: 'post',
		data
	})
}

/**
 * 评委批改试卷列表页面
 * @param {*} data 
 * 【必填 competition_id paper_id teacher_id】
 */
export function paperMarkListData(data){
	return request({
		url: '/api/contest/select_mark',
		method: 'post',
		data
	})
}

/**
 * 公布成绩
 * @param {*} data 
 */
export function publishedResultsData(data){
	return request({
		url: '/api/contest/publish_result',
		method: 'post',
		data
	})
}
/**
 * 获取该学生所有参加的活动列表
 * @param {*} data 
 * 【必填 competition_id student_id】
 */
export function getStudentEventData(data){
	return request({
		url: '/api/contest/get_event',
		method: 'post',
		data
	})
}

/**
 * 评委批阅试卷页面
 * @param {*} data 
 * 【必填 competition_id paper_id student_id】
 */
export function correctPaperData(data){
	return request({
		url: '/api/contest/correct_paper',
		method: 'post',
		data
	})
}

/**
 * 评委批阅试卷提交批改
 * @param {*} data 
 * 【必填 competition_id paper_id student_id remark】
 */
export function correctPaperSubmitData(data){
	return request({
		url: '/api/contest/correct_submit',
		method: 'post',
		data
	})
}

/**
 * 排行榜
 * @param {*} data 
 * 【必填 competition_id】
 */
export function rankListData(data){
	return request({
		url: '/api/contest/rank_list',
		method: 'post',
		data
	})
}

/**
 * 训练内容主页获取数据
 * @param {*} data 
 */
export function selectTrainData(data){
	return request({
		url: '/api/train/select_path',
		method: 'post',
		data
	})
}

/**
 * 任务下级活动列表页获取数据
 * @param {*} data 
 * 【必填 task_id competition_id】
 */
export function selectEventData(data){
	return request({
		url: '/api/train/select_item',
		method: 'post',
		data
	})
}

/**
 * 训练做题页面获取数据
 * @param {*} data 
 * 【必填 competition_id paper_id】
 */
export function userOpenTrainAnswerData(data){
	return request({
		url: '/api/train/answer_topic',
		method: 'post',
		data
	})
}

/**
 * 训练批改列表页
 * @param {*} data
 * 【必填 competition_id 】 
 */
export function trainMarkListData(data){
	return request({
		url: '/api/train/select_mark',
		method: 'post',
		data
	})
}

/**
 * 训练考生查看单个活动结果
 * @param {*} data 
 */
export function userCheckResultData(data){
	return request({
		url: '/api/train/check_result',
		method: 'post',
		data
	})
}

/**
 * 评委批阅活动页面
 * @param {*} data 
 * 【必填 competition_id paper_id student_id】
 */
export function CorrectPaperData(data){
	return request({
		url: '/api/train/correct_paper',
		method: 'post',
		data
	})
}

/**
 * 获取该活动下所有训练者
 * @param {*} data 
 * 【必填 competition_id paper_id】
 */
export function getTrainAllEventData(data){
	return request({
		url: '/api/train/get_allevent',
		method: 'post',
		data
	})
}

/**
 * 评委训练批改提交
 * @param {*} data 
 * 【必填 competition_id paper_id student_id remarks:[score:'',comments:'']】
 */
export function correctStudentSubmitData(data){
	return request({
		url: '/api/train/correct_submit',
		method: 'post',
		data
	})
}

/**
 * 训练修订活动题目
 * @param {*} data 
 * 【必填 competition_id paper_id】
 */
export function reviseTrainData(data){
	return request({
		url: '/api/train/revise_data',
		method: 'post',
		data
	})
}

/**
 * 训练修订页面获取数据
 * @param {*} data 
 * 【必填 competition_id paper_id】
 */
export function studentReviseTrain(data){
	return request({
		url: '/api/train/select_revise',
		method: 'post',
		data
	})
}

/**
 * 修订提交保存
 * @param {*} data 
 */
export function studentReviseSubmit(data){
	return request({
		url: '/api/train/revise_submit',
		method: 'post',
		data
	})
}


/**
 * 重新做一次活动
 * @param {*} data
 * 【必填 competition_id paper_id】 
 */
export function doActivityAgain(data){
	return request({
		url: '/api/train/do_again',
		method: 'post',
		data
	})
}

/**
 * 重现赛批改页面
 * @param {*} data 
 */
export function replayMarkList(data){
	return request({
		url:'/api/contest/replay_mark_list',
		method:'post',
		data
	})
}

/**
 * 专题比赛批改页面
 * @param {*} data 
 */
export function specialContestMarkList(data){
	return request({
		url:'/api/contest/special_contest_mark_list',
		method:'post',
		data
	})
}

/**
 * 专题训练批改页面
 * @param {*} data
 */
export function specialTrainingMarkList(data){
	return request({
		url:'/api/contest/special_training_mark_list',
		method:'post',
		data
	})
}



/**
 * 难易度判断
 * @param {*} date 
 * @param {*} fmt 
 */
export function retrunDifficulty(data){
	if (data === 1) {
	return "简单";
	} else if (data === 2) {
	return "一般";
	} else if (data === 3) {
	return "困难";
	}else{
		return '';
	}
}

/**
 * 查询题型名称,中文
 * @param {*} data 为题型类别
 */
export function returnQuestionType(data) {
	if(data===1){
		return '单选题'
	}else if(data===2){
		return '多选题'
	}else if(data===3){
		return '判断题'
	}else if(data===4){
		return '填空题'
	}else if(data===5){
		return '选词填空题'
	}else if(data===6){
		return '连线题'
	}else if(data===7){
		return '名词解释题'
	}else if(data===8){
		return '简答题'
	}else if(data===9){
		return '实训题'
	}else if(data===10){
		return '排序题'
	}
}

/**
 * 查询题型名称,英文
 * @param {*} data 为题型类别
 */
export function returnType(data) {
	if(data===1){
		return 'singleChoice'
	}else if(data===2){
		return 'multipleChoice'
	}else if(data===3){
		return 'jugeMent'
	}else if(data===4){
		return 'fill'
	}else if(data===5){
		return 'gapFill'
	}else if(data===6){
		return 'line'
	}else if(data===7){
		return 'explain'
	}else if(data===8){
		return 'short'
	}else if(data===9){
		return 'train'
	}else if(data===10){
		return 'multipleSort'
	}
}

/**
 * 阿拉伯数字转中文
 */
export function NumberToChinese(num){
	var arr1 = new Array('零', '一', '二', '三', '四', '五', '六', '七', '八', '九');
    var arr2 = new Array('', '十', '百', '千', '万', '十', '百', '千', '亿', '十', '百', '千','万', '十', '百', '千','亿');//可继续追加更高位转换值
    if(!num || isNaN(num)){
        return "零";
    }
    var english = num.toString().split("")
    var result = "";
    for (var i = 0; i < english.length; i++) {
        var des_i = english.length - 1 - i;//倒序排列设值
        result = arr2[i] + result;
        var arr1_index = english[des_i];
        result = arr1[arr1_index] + result;
    }
    //将【零千、零百】换成【零】 【十零】换成【十】
    result = result.replace(/零(千|百|十)/g, '零').replace(/十零/g, '十');
    //合并中间多个零为一个零
    result = result.replace(/零+/g, '零');
    //将【零亿】换成【亿】【零万】换成【万】
    result = result.replace(/零亿/g, '亿').replace(/零万/g, '万');
    //将【亿万】换成【亿】
    result = result.replace(/亿万/g, '亿');
    //移除末尾的零
    result = result.replace(/零+$/, '')
    //将【一十】换成【十】
    result = result.replace(/^一十/g, '十');
    return result;
}

/**
 * 判断答案是否为空
 */
export function answeIfNull(data,type){
	let status = 0
	if(type===1){
		if(data!==''){
			status = 1
		}	
	}else if(type===2){
		if(data.length>0){
			status = 1
		}
	}else if(type===3){
		if(data!==''){
			status = 1
		}
	}else if(type===4){
		if(data.length>0){
			let num = 0
			for(let i=0;i<data.length;i++){
				if(data[i]){
					status = 1
				}else{
					num++
				}
			}
			if(num==data.length){
				status = 0
			}
		}
	}else if(type===5){
	}else if(type===6){
	}else if(type===7){
		if(data!==''){
			status = 1
		}
	}else if(type===8){
		if(data!==''){
			status = 1
		}
	}else if(type===9){
		if(data.content||data.file.length>0){
			status = 1
		}
	}else if(type===10){
		let num = 0
		if(data.length>0){
			for(let i=0;i<data.length;i++){
				if(data[i]){
					status = 1
				}else{
					num++
				}
			}
			if(num==data.length){
				status = 0
			}
		}
	}
	return status
}

